import { render, staticRenderFns } from "./HelpPopup.vue?vue&type=template&id=736efc78&scoped=true"
import script from "./HelpPopup.vue?vue&type=script&lang=js"
export * from "./HelpPopup.vue?vue&type=script&lang=js"
import style0 from "./HelpPopup.vue?vue&type=style&index=0&id=736efc78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736efc78",
  null
  
)

export default component.exports